import { MagazineArticleDetailsProps } from '@uikit/components/Magazine/MagazineArticleDetails/interfaces';
import MagazineArticleDetails from '@uikit/components/Magazine/MagazineArticleDetails/MagazineArticleDetails';

const MagazineArticleDetailsWrapper = (props: MagazineArticleDetailsProps) => {
  return <MagazineArticleDetails {...props} />;
};

export default MagazineArticleDetailsWrapper;
